import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Zip = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 24 24'
    >
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m21,6.75l0,14.25c0,0.8 -0.32,1.56 -0.88,2.12c-0.56,0.56 -1.32,0.88 -2.12,0.88l-5.33,-0.04l-0.03,-1.42l5.36,-0.03c0.4,0 0.78,-0.16 1.06,-0.44c0.28,-0.28 0.44,-0.66 0.44,-1.06l0,-14.25l-3,0c-0.6,0 -1.17,-0.24 -1.59,-0.66c-0.42,-0.42 -0.66,-0.99 -0.66,-1.59l0,-3l-8.25,0c-0.4,0 -0.78,0.16 -1.06,0.44c-0.28,0.28 -0.44,0.66 -0.44,1.06l0,13.5l-1.5,0l0,-13.5c0,-0.8 0.32,-1.56 0.88,-2.12c0.56,-0.56 1.32,-0.88 2.12,-0.88l8.25,0l6.75,6.75z'
          fill={primaryColorToUse}
        />
        <g transform='translate(2.5,0)' />
        {/* <!-- barra superiore della Z --> */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m-0.52,17.77l3.1,0l0,1.19l-3.1,0l0,-1.19z'
          fill={primaryColorToUse}
        />
        {/* <!-- diagonale della Z, i primi e ultimi due punti coincidono con i corner delle barre --> */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m2.59,18.89l-1,-0.3l-2.11,4.01l1.24,0l1.87,-3.71z'
          fill={primaryColorToUse}
        />
        {/* <!-- barra inferiore della Z --> */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m-0.52,22.59l3.1,0l0,1.18l-3.1,0l0,-1.18z'
          fill={primaryColorToUse}
        />
        {/* <!-- I --> */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m3.4,17.77l1.18,0l0,6l-1.18,0l0,-6z'
          fill={primaryColorToUse}
        />
        {/* <!-- P --> */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m7.8,17.77l-2.4,0l0,6l1.19,0l0,-2.01l1.2,0c0.43,0 0.8,-0.09 1.1,-0.26c0.3,-0.17 0.54,-0.41 0.69,-0.71c0.17,-0.31 0.25,-0.66 0.24,-1.02c0,-0.37 -0.07,-0.71 -0.23,-1.01c-0.16,-0.3 -0.4,-0.55 -0.69,-0.72c-0.3,-0.18 -0.67,-0.27 -1.1,-0.27zm0.82,2c0,0.2 -0.04,0.4 -0.13,0.57c-0.08,0.16 -0.2,0.28 -0.36,0.37c-0.17,0.08 -0.36,0.12 -0.56,0.12l-0.99,0l0,-2.11l0.99,0c0.33,0 0.58,0.09 0.77,0.27c0.19,0.18 0.28,0.45 0.28,0.78z'
          fill={primaryColorToUse}
        />
      </g>
    </svg>
  );
};
